import { FC } from 'react';
import { PageUsageForKeys, PageUsageForType } from '../../pages.interfaces';
import { Tag } from 'antd';
import { capitalizeString } from '../../../../common/utils';

interface Props {
  value: PageUsageForType;
}

export const PageUsageForTag: FC<Props> = ({ value }) => {
  if (!('type' in value) && value[PageUsageForKeys.Bot]) {
    return <Tag color="geekblue">{
      `${ capitalizeString(value[PageUsageForKeys.Bot]) }${ capitalizeString(PageUsageForKeys.Bot) }`
    }</Tag>;
  }

  return <Tag>default</Tag>;
};
